import React, { useState, useMemo, useEffect } from "react"
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Fab,
  Stack,
} from "@mui/material"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../../../../../base/services/ResApi"
import { FetchErrorHandeling } from "../../../../../../base/errorHandeling/FetchErrorHandeling"
import TroubleshootIcon from "@mui/icons-material/Troubleshoot"

import { DemoContainer } from "@mui/x-date-pickers/internals/demo"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import dayjs from "dayjs"
import FormControl from "@mui/material/FormControl"
import Alerts from "../../../../../../base/errorHandeling/Alerts"

const OperationHistory = ({ onClose, serialNo }) => {
  const [appRowCount, setAppRowCount] = useState(0)
  const [approvedData, setApprovedData] = useState([])
  const [apprLoading, setApprDataLoading] = useState(true)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])
  const [isUnauhtError, setIsUnauhtError] = useState(false)

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")

  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 10,
  })

  const [fromDate, setFromDate] = useState(dayjs().format("YYYY/MM/DD"))
  const [toDate, setToDate] = useState(dayjs().format("YYYY/MM/DD"))
  const [isSearch, setIsSearch] = useState(false)

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setSuccessMessages([])
        setIsSuccess(false)
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  const handleSearch = () => {
    setIsSearch(true)
  }

  const fromDateChange = (e) => {
    setFromDate(dayjs(e).format("YYYY/MM/DD"))
  }
  const toDateChange = (e) => {
    setToDate(dayjs(e).format("YYYY/MM/DD"))
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "operation",
        header: "Operation",
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "createdTime",
        header: "Date/Time",
      },
      {
        accessorKey: "desc",
        header: "Description",
      },
      {
        accessorKey: "updatedTime",
        header: "Op. Executed Time",
      },
    ],
    []
  )

  //Approve Data fetch
  useEffect(() => {
    if (isSearch || pagination.pageIndex || pagination.pageSize) {
      setApprDataLoading(true)
      let apprvConfig = {
        headers: {
          Action: "VIEW_TMNL_OPS_DATA",
          "Page-Number": pagination.pageIndex + 1,
          "Page-Size": pagination.pageSize,
          "Sort-Column": "operation",
          "Sort-Order": "desc",
          FDT: fromDate,
          TDT: toDate,
          SN: serialNo,
        },
      }

      api
        .get("/terminal/operations", apprvConfig)
        .then((res) => {
          setIsSearch(false)
          setApprovedData(res.data?.dataList)
          setAppRowCount(res.data?.total)
          setApprDataLoading(false)
          setIsUnauhtError(false)
        })
        .catch((err) => {
          setIsSearch(false)
          setApprDataLoading(false)
          FetchErrorHandeling(err, setIserror, setErrorMessages, setIserrorShow)
        })
    }
  }, [isSearch, isUnauhtError, pagination.pageIndex, pagination.pageSize])

  return (
    <div>
      <DialogContent dividers>
        <div>
          <Alerts
            iserror={iserror}
            errorMessages={errorMessages}
            isSuccess={isSuccess}
            successMessages={successMessages}
            iserrorShow={iserrorShow}
          />
        </div>
        <br />
        <Stack direction="row" spacing={3}>
          <FormControl>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={["DatePicker"]}>
                <DatePicker
                  value={dayjs(fromDate)}
                  onChange={fromDateChange}
                  label="From"
                />
                <DatePicker
                  value={dayjs(toDate)}
                  onChange={toDateChange}
                  label="To"
                />
              </DemoContainer>
            </LocalizationProvider>
          </FormControl>
          <div style={{ marginTop: 12 }}>
            <Fab onClick={handleSearch} variant="extended" color="primary">
              <TroubleshootIcon sx={{ mr: 1 }} />
              Search
            </Fab>
          </div>
        </Stack>
        <br />
        <br />
        <MaterialReactTable
          columns={columns}
          data={approvedData ?? []}
          state={{
            columnFilters,
            globalFilter,
            pagination,
            showProgressBars: apprLoading,
          }}
          getRowId={(row) => row.phoneNumber}
          initialState={{
            showColumnFilters: false,
            columnVisibility: {
              appId: false,
              versionCode: false,
              createdBy: false,
            },
          }}
          manualPagination
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          rowCount={appRowCount}
          muiTablePaginationProps={{
            rowsPerPageOptions: [10],
          }}
          enableColumnOrdering
          enableGrouping
        />
        <br />
        <br />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
      </DialogActions>
    </div>
  )
}

export default OperationHistory
